export const agentConversations = [
    {
        id: 'conversation11',
        type: 'audio',
        dateTaken: '11/17/2022',
        csat: 65,
        qaScore: 69,
        nytroRating: 4.5,
        actionsPending: '01/06',
        comments: 1,
        uuid: 147629
    },
    {
        id: 'conversation12',
        type: 'audio',
        dateTaken: '11/15/2022',
        csat: 63,
        qaScore: 65,
        nytroRating: 4,
        actionsPending: '02/06',
        comments: 1,
        uuid: 147629
    },
    {
        id: 'conversation13',
        type: 'chat',
        dateTaken: '11/15/2022',
        csat: 65,
        qaScore: 70,
        nytroRating: 3.5,
        actionsPending: '03/06',
        comments: 6,
        uuid: 147629
    },
    {
        id: 'conversation14',
        type: 'audio',
        dateTaken: '11/15/2022',
        csat: 70,
        qaScore: 77,
        nytroRating: 4,
        actionsPending: '04/06',
        comments: 4,
        uuid: 147629
    },
    {
        id: 'conversation15',
        type: 'chat',
        dateTaken: '11/14/2022',
        csat: 80,
        qaScore: 78,
        nytroRating: 4.5,
        actionsPending: '05/06',
        comments: 2,
        uuid: 147629
    },
    {
        id: 'conversation16',
        type: 'audio',
        dateTaken: '11/15/2022',
        csat: 59,
        qaScore: 48,
        nytroRating: 4.5,
        actionsPending: '06/06',
        comments: 3,
        uuid: 147629
    },
    {
        id: 'conversation17',
        type: 'chat',
        dateTaken: '11/17/2022',
        csat: 88,
        qaScore: 85,
        nytroRating: 4.6,
        actionsPending: '07/06',
        comments: 8,
        uuid: 147629
    },
    {
        id: 'conversation18',
        type: 'chat',
        dateTaken: '11/10/2022',
        csat: 59,
        qaScore: 69,
        nytroRating: 3.5,
        actionsPending: '08/06',
        comments: 5,
        uuid: 147629
    },
    {
        id: 'conversation19',
        type: 'audio',
        dateTaken: '10/30/2022',
        csat: 65,
        qaScore: 69,
        nytroRating: 4.5,
        actionsPending: '01/06',
        comments: 1,
        uuid: 147629
    },
    {
        id: 'conversation20',
        type: 'audio',
        dateTaken: '10/27/2022',
        csat: 63,
        qaScore: 65,
        nytroRating: 4,
        actionsPending: '02/06',
        comments: 1,
        uuid: 147629
    },
    {
        id: 'conversation21',
        type: 'chat',
        dateTaken: '10/25/2022',
        csat: 65,
        qaScore: 70,
        nytroRating: 3.5,
        actionsPending: '03/06',
        comments: 6,
        uuid: 147629
    },
    {
        id: 'conversation22',
        type: 'audio',
        dateTaken: '10/23/2022',
        csat: 70,
        qaScore: 77,
        nytroRating: 4,
        actionsPending: '04/06',
        comments: 4,
        uuid: 147629
    },
    {
        id: 'conversation23',
        type: 'chat',
        dateTaken: '10/24/2022',
        csat: 80,
        qaScore: 78,
        nytroRating: 4.5,
        actionsPending: '05/06',
        comments: 2,
        uuid: 147629
    },
    {
        id: 'conversation24',
        type: 'audio',
        dateTaken: '10/20/2022',
        csat: 59,
        qaScore: 48,
        nytroRating: 4.5,
        actionsPending: '06/06',
        comments: 3,
        uuid: 147629
    },
    {
        id: 'conversation25',
        type: 'chat',
        dateTaken: '10/17/2022',
        csat: 88,
        qaScore: 85,
        nytroRating: 4.6,
        actionsPending: '07/06',
        comments: 8,
        uuid: 147629
    },
    {
        id: 'conversation26',
        type: 'chat',
        dateTaken: '10/10/2022',
        csat: 59,
        qaScore: 69,
        nytroRating: 3.5,
        actionsPending: '08/06',
        comments: 5,
        uuid: 147629
    },
    {
        id: 'conversation27',
        type: 'chat',
        dateTaken: '9/10/2022',
        csat: 59,
        qaScore: 69,
        nytroRating: 3.5,
        actionsPending: '08/06',
        comments: 5,
        uuid: 147629
    },
    {
        id: 'conversation28',
        type: 'audio',
        dateTaken: '9/30/2022',
        csat: 65,
        qaScore: 69,
        nytroRating: 4.5,
        actionsPending: '01/06',
        comments: 1,
        uuid: 147629
    },
    {
        id: 'conversation29',
        type: 'audio',
        dateTaken: '9/27/2022',
        csat: 63,
        qaScore: 65,
        nytroRating: 4,
        actionsPending: '02/06',
        comments: 1,
        uuid: 147629
    },
    {
        id: 'conversation30',
        type: 'chat',
        dateTaken: '9/25/2022',
        csat: 65,
        qaScore: 70,
        nytroRating: 3.5,
        actionsPending: '03/06',
        comments: 6,
        uuid: 147629
    },
    {
        id: 'conversation31',
        type: 'audio',
        dateTaken: '9/23/2022',
        csat: 70,
        qaScore: 77,
        nytroRating: 4,
        actionsPending: '04/06',
        comments: 4,
        uuid: 147629
    },
    {
        id: 'conversation32',
        type: 'chat',
        dateTaken: '9/24/2022',
        csat: 80,
        qaScore: 78,
        nytroRating: 4.5,
        actionsPending: '05/06',
        comments: 2,
        uuid: 147629
    },
    {
        id: 'conversation33',
        type: 'audio',
        dateTaken: '9/20/2022',
        csat: 59,
        qaScore: 48,
        nytroRating: 4.5,
        actionsPending: '06/06',
        comments: 3,
        uuid: 147629
    },
    {
        id: 'conversation34',
        type: 'chat',
        dateTaken: '9/17/2022',
        csat: 88,
        qaScore: 85,
        nytroRating: 4.6,
        actionsPending: '07/06',
        comments: 8,
        uuid: 147629
    },
    {
        id: 'conversation35',
        type: 'chat',
        dateTaken: '9/10/2022',
        csat: 59,
        qaScore: 69,
        nytroRating: 3.5,
        actionsPending: '08/06',
        comments: 5,
        uuid: 147629
    },
]